export default "__VITE_ASSET__FHyJYduT__"